exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-info-screen pre {\n  margin: 2em;\n}\n", ""]);

// exports
